/* eslint-disable */
/* eslint-disable no-restricted-syntax */
/* eslint-disable object-shorthand */

// react imports
import { useState, useEffect } from "react";

// @mui material components
import { Grid, Divider } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

// notistack imports
import { useSnackbar } from "notistack";

import { Select } from '@mui/material';
// import NativeSelect from "@mui/material/NativeSelect";

// @mui material components
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";

// Material Dashboard 2 React context
import { setCart, setLocalCustomization, useMaterialUIController, setChosenAddress, setFinalAddress, setPageState } from "context";

// Firebase imports
import { collection, getDocs, doc, setDoc, deleteDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { db } from "../../../../../../Firebase";

function CustomizationForm() {

  const [controller, dispatch] = useMaterialUIController();
  const { cart, localCustomization, editOrder } = controller;
  const { enqueueSnackbar } = useSnackbar();

  const auth = getAuth();
  const user = auth.currentUser;

  const [proceedToShipping, setProceedToShipping] = useState(false);

  const [customizations, setCustomizations] = useState([]);
  const [nickName, setNickName] = useState(localCustomization.nickName || "");
  const [clinicName, setClinicName] = useState(localCustomization.clinicName || "");
  const [line2, setLine2] = useState(localCustomization.line2 || "");
  const [line3, setLine3] = useState(localCustomization.line3 || "");

  const [nickNameError, setNickNameError] = useState(false);
  const [clinicNameError, setClinicNameError] = useState(false);

  const canCustomizeArray = cart.filter((customizedItem) => customizedItem.willCustomize === true);
  const customizationRequired = cart.map((x) => x.customizationRequired).includes(true);

  const saveCustomization = () => {
    if (nickName.length === 0) {
      setNickNameError(true);
    } else {
      setNickNameError(false);
    }

    if (clinicName.length === 0) {
      setClinicNameError(true);
    } else {
      setClinicNameError(false);
    }

    if (clinicName.length !== 0) {
      setClinicNameError(false);
      setProceedToShipping(true);
      const updatedCartItem = cart.map((x) =>
        x.willCustomize === true
          ? {
              ...x,
              customizationItems: [
                { title: "Clinic/Company", item: clinicName },
                { title: "Line 2", item: line2 },
                { title: "Line 3", item: line3 },
              ],
            }
          : x
      );
      const newCustomization = {
        customized: true,
        nickName: nickName || "",
        clinicName: clinicName || "",
        line2: line2 || "",
        line3: line3 || "",
      };
      setLocalCustomization(dispatch, newCustomization);
      window.localStorage.setItem("customization", JSON.stringify(newCustomization));
      (async () => {
        const userCustomizationRef = doc(db, "USERS", user.uid, "CUSTOMIZATION_OPTIONS", newCustomization.nickName || "");
        await setDoc(userCustomizationRef, newCustomization);
      })()
      setCart(dispatch, updatedCartItem);
      window.localStorage.setItem("cart", JSON.stringify(updatedCartItem));
      const variant = "success";
      enqueueSnackbar("Your customization has been saved!", {
        variant,
        autoHideDuration: 2000,
      });
      console.log(cart);
      setPageState(dispatch, "Shipping");
    }
  };

  const removeCustomization = () => {
    setClinicNameError(false);
    setNickNameError(false);
    setProceedToShipping(true);
    const updatedCartItem = cart.map((x) =>
      x.willCustomize === true ? { ...x, willCustomize: false, customizationOptions: [] } : x
    );
    setCart(dispatch, updatedCartItem);
    window.localStorage.setItem("cart", JSON.stringify(updatedCartItem));
    const blankCustomization = { customized: false, clinicName: "", line2: "", line3: "" };
    window.localStorage.setItem("customization", JSON.stringify(blankCustomization));
    const variant = "warning";
    enqueueSnackbar("Your customization has been removed.", {
      variant,
      autoHideDuration: 2000,
    });
    console.log(cart);
    setPageState(dispatch, "Shipping");
  };

  useEffect(() => {
    (async () => {
    const userId = user.uid;
    const colRef = await getDocs(collection(db, "USERS", userId, "CUSTOMIZATION_OPTIONS"));
    const customizationArray = colRef.docs.map((el) => ({ ...el.data(), id: el.id }));
    // Pre-populate with last saved customization
    if (customizationArray.length > 0){
      setCustomizations(customizationArray);
      const firstCustomization = customizationArray[0];
      setNickName(firstCustomization.nickName);
      setClinicName(firstCustomization.clinicName);
      setLine2(firstCustomization.line2);
      setLine3(firstCustomization.line3);
    }
    })();
  }, []);

  const CustomizationSelect = () => {

    const [selectedCustomization, setSelectedCustomization] = useState('');
    const handleChange = (event) => {
      const selected = customizations.find(cus => cus.id === event.target.value);
      setSelectedCustomization(event.target.value);
      setNickName(selected.nickName);
      setClinicName(selected.clinicName);
      setLine2(selected.line2);
      setLine3(selected.line3);
    };

    const formatCustomization = (customization, idx) => {
      return (
        <MDBox sx={{ whiteSpace: 'pre-line', py: 1 }}>
          <MDTypography variant="p">
            {customization
              ? <>
                {customization.nickName || customization.id || `Customization ${idx}`}
              </>
              : <>
                {nickName || 'Select saved customization'}
              </>}
          </MDTypography>
        </MDBox>
      );
    };

    return (
      <FormControl fullWidth>
        <Select
          value={selectedCustomization}
          onChange={handleChange}
          displayEmpty
          renderValue={(value) => {
            if (!value) {
              return <>
                <MDBox sx={{ position: 'relative', width: '100%', padding: '8px 4px' }}>
                  <MDTypography variant="p" color="text.secondary" sx={{ padding: '8px 4px' }}>
                    Select saved customization
                  </MDTypography>
                  <MDBox sx={{ position: 'absolute', top: '40%', right: 0, transform: 'scaleY(50%) translateY(-50%)', paddingRight: '5px' }}>▼</MDBox>
                </MDBox>
              </>
            }
            const customization = customizations.find(addr => addr.id === value);
            return formatCustomization(customization);
          }}
        >
          {customizations.map((customization, i) => (
            <MenuItem key={customization.id} value={customization.id}>
              {formatCustomization(customization, i)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };

  return (
    <MDBox p={2}>
      <Grid container spacing={2}>
        {canCustomizeArray.map((item) => (
          <Grid item key={item.newID} xs={6} sm={4}>
            <MDBox
              component="img"
              src={item.image}
              alt={item.newID}
              borderRadius="lg"
              shadow="md"
              width="100%"
              height="100%"
              position="relative"
              zIndex={1}
            />
          </Grid>
        ))}
      </Grid>
      <MDBox pt={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Saved customizations
        </MDTypography>
      </MDBox>
      <MDBox py={2}>
        <CustomizationSelect />
      </MDBox>
      <MDBox pt={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          Customization Info
        </MDTypography>
      </MDBox>
      <MDBox py={2}>
        {clinicNameError && (
          <MDTypography variant="body2" color="error">
            Please enter a clinic name.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Customization Name"
          value={nickName || ""}
          inputProps={{ maxLength: 35 }}
          style={{ width: "100%" }}
          onChange={(e) => {
            setNickName(e.target.value || "");
          }}
        />
      </MDBox>
      <MDBox py={2}>
        {clinicNameError && (
          <MDTypography variant="body2" color="error">
            Please enter a clinic name.
          </MDTypography>
        )}
        <MDInput
          type="text"
          label="Clinic/Company Name"
          value={clinicName}
          inputProps={{ maxLength: 35 }}
          style={{ width: "100%" }}
          onChange={(e) => {
            setClinicName(e.target.value || "");
          }}
        />
      </MDBox>
      <MDBox py={2}>
        <MDInput
          type="text"
          label="2nd Line"
          value={line2}
          inputProps={{ maxLength: 35 }}
          style={{ width: "100%" }}
          onChange={(e) => {
            setLine2(e.target.value || "");
          }}
        />
      </MDBox>
      <MDBox py={2}>
        <MDInput
          type="text"
          label="3rd Line"
          value={line3}
          inputProps={{ maxLength: 35 }}
          style={{ width: "100%" }}
          onChange={(e) => {
            setLine3(e.target.value || "");
          }}
        />
      </MDBox>
      <MDBox pt={2}>
        <MDButton
          variant={proceedToShipping ? "contained" : "outlined"}
          color={proceedToShipping ? "success" : "info"}
          sx={{ width: "100%" }}
          onClick={saveCustomization}
        >
          {proceedToShipping ? "Proceed to Shipping" : "Save Customization"}
        </MDButton>
        {!customizationRequired && (
          <MDButton
            variant="text"
            color="secondary"
            sx={{ width: "100%", marginTop: ".5rem" }}
            onClick={removeCustomization}
          >
            nevermind, I don&apos;t want to customize these items
          </MDButton>
        )}
      </MDBox>
      <Divider />
      {editOrder && (
        <MDBox py={2}>
          <MDButton
            color="dark"
            onClick={() => {
              setPageState(dispatch, "Review");
            }}
            fullWidth
          >
            return to order review
          </MDButton>
        </MDBox>
      )}
    </MDBox>
  );
}

export default CustomizationForm;
